export default "__VITE_ASSET__DhnqVlf4__"